export enum Resolutions {
  'XXL' = 'xxl',
  'XL' = 'xl',
  'L' = 'l',
  'M' = 'm',
  'S' = 's',
  'XS' = 'xs',
  'XXS' = 'xxs',
}

export enum Sizes {
  Micro = 'micro',
  ExtraSmall = 'xsmall',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  ExtraLarge = 'xlarge',
}

export enum Variants {
  Filled = 'filled',
  Outlined = 'outlined',
  Transparent = 'transparent',
  Subtle = 'subtle',
}

export enum Positions {
  Top = 'top',
  TopLeft = 'topLeft',
  TopRight = 'topRight',
  Bottom = 'bottom',
  BottomLeft = 'bottomLeft',
  BottomRight = 'bottomRight',
  Left = 'left',
  Right = 'right',
  Center = 'center',
  Side = 'side',
}

export enum Alignments {
  Top = 'top',
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
  LeftAndRight = 'leftAndRight',
  Center = 'center',
  Fill = 'fill',
}

export enum Directions {
  Horizontal = 'horizontal',
  Vertical = 'vertical',
}

export enum Sorts {
  Asc = 'ascend',
  Desc = 'descend',
}

export enum BgColors {
  Surface = 'surface',
  Base = 'base',
  Raised = 'raised',
  Section = 'section',
}

export enum Shapes {
  Rounded = 'rounded',
  Square = 'square',
}

export enum TextTypes {
  Paragraph = 'p',
  Span = 'span',
  Label = 'label',
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  H5 = 'h5',
  H6 = 'h6',
}

export enum Levels {
  'One' = 1,
  'Two' = 2,
  'Three' = 3,
  'Four' = 4,
  'Five' = 5,
  'Six' = 6,
}

/** Class names */

export const ACCORDION_CLASS = 'shell-accordion';
export const ACCORDION_PANEL_CLASS = 'shell-accordion-panel';
export const ALERT_CLASS = 'shell-alert';
export const AVATAR_CLASS = 'shell-avatar';
export const ARROW_KEYPAD_CLASS = 'shell-arrow-keypad';
export const BADGE_CLASS = 'shell-badge';
export const BREADCRUMB_CLASS = 'shell-breadcrumb';
export const BUTTON_CLASS = 'shell-button';
export const BUTTON_GROUP_CLASS = 'shell-button-group';
export const CARD_CLASS = 'shell-card';
export const CHART_CLASS = 'shell-chart';
export const CHECKBOX_CLASS = 'shell-checkbox';
export const CALENDAR_CLASS = 'shell-calendar';
export const DATE_PICKER_CLASS = 'shell-date-picker';
export const DATE_INPUT_DAY_ID_SUFFIX = 'shell-date-input-day';
export const DATE_INPUT_MONTH_ID_SUFFIX = 'shell-date-input-month';
export const DATE_INPUT_YEAR_ID_SUFFIX = 'shell-date-input-year';
export const DIVIDER_CLASS = 'shell-divider';
export const DRAWER_CLASS = 'shell-drawer';
export const DROPDOWN_CLASS = 'shell-dropdown';
export const DROPDOWN_CONTAINER_CLASS = `${DROPDOWN_CLASS}-container`;
export const DROPDOWN_CONTAINER_OVERLAY_CLASS = `${DROPDOWN_CONTAINER_CLASS}-overlay`;
export const EMPTY_STATE_CLASS = 'shell-empty-state';
export const FORM_FIELD_CLASS = 'shell-form-field';
export const ICON_CLASS = 'shell-icon';
export const LOADING_CLASS = 'shell-loading';
export const MENU_CLASS = 'shell-menu';
export const MODAL_CLASS = 'shell-modal';
export const MODAL_CONTAINER_CLASS = `${MODAL_CLASS}-container`;
export const NAV_BAR_CLASS = 'shell-nav-bar';
export const PAGINATION_CLASS = 'shell-pagination';
export const PECTEN_CLASS = 'shell-pecten';
export const POPCONFIRM_CLASS = 'shell-popconfirm';
export const POPOVER_CLASS = 'shell-popover';
export const POPOVER_OVERLAY_CLASS = 'shell-popover-overlay';
export const PROGRESS_BAR_LINEAR = 'shell-linear-progress-bar';
export const PROGRESS_BAR_CIRCLE = 'shell-circle-progress-bar';
export const RADIO_BUTTON_CLASS = 'shell-radio-button';
export const SELECT_CLASS = 'shell-select';
export const SELECT_ERROR_CLASS = `${SELECT_CLASS}-error`;
export const SLIDER_CLASS = 'shell-slider';
export const STAT_CLASS = 'shell-stat';
export const STEPPER_CLASS = 'shell-stepper';
export const TABLE_CLASS = 'shell-table';
export const TABLE_SORTER_BUTTON_CLASS = `${TABLE_CLASS}-sorter-button`;
export const TABLE_ASC_ICON_CLASS = `${TABLE_CLASS}-asc-icon`;
export const TABLE_DESC_ICON_CLASS = `${TABLE_CLASS}-desc-icon`;
export const TABLE_NO_DIR_ICON_CLASS = `${TABLE_CLASS}-no-dir-icon`;
export const TABLE_FILTER_BUTTON_CLASS = `${TABLE_CLASS}-filter-button`;
export const TABLE_PIN_BUTTON_CLASS = `${TABLE_CLASS}-pin-button`;
export const TABLE_RESIZER_CLASS = `${TABLE_CLASS}-resizer`;
export const TABLE_EXPANDER_BUTTON_CLASS = `${TABLE_CLASS}-expander-button`;
export const TABLE_DRAGGABLE_BUTTON_CLASS = `${TABLE_CLASS}-draggable-button`;
export const TABS_CLASS = 'shell-tabs';
export const TAG_CLASS = 'shell-tag';
export const SECTION_CLASS = 'shell-text-article';
export const DISPLAY_CLASS = 'shell-text-display';
export const HEADING_CLASS = 'shell-text-heading';
export const LABEL_CLASS = 'shell-text-label';
export const LINK_CLASS = 'shell-text-link';
export const PARAGRAPH_CLASS = 'shell-text-paragraph';
export const TEXT_AREA_CLASS = 'shell-text-area';
export const TEXT_INPUT_CLASS = 'shell-text-input';
export const TIMELINE_CLASS = 'shell-timeline';
export const TOGGLE_CLASS = 'shell-toggle';
export const TOGGLE_BUTTON_CLASS = 'shell-toggle';
export const TOGGLE_SWITCH_CLASS = `${TOGGLE_CLASS}-switch`;
export const TOOLTIP_CLASS = 'shell-tooltip';
export const TREE_CLASS = 'shell-tree';
export const TREE_CHECKBOX_CLASS = `${TREE_CLASS}-checkbox-wrapper`;
export const TREE_CHECKBOX_CHECKED_CLASS = `${TREE_CHECKBOX_CLASS}-checked`;
export const TREE_CHECKBOX_UNCHECKED_CLASS = `${TREE_CHECKBOX_CLASS}-unchecked`;
export const TREE_CHECKBOX_INDETERMINATE_CLASS = `${TREE_CHECKBOX_CLASS}-indeterminate`;

/** Styles */

export enum ZIndexes {
  'ELEVATED' = 10,
  'DATE_PICKER' = 2,
  'MENU' = 1,
  'MODAL' = 2,
  'NAVBAR' = 1,
  'DRAWER' = 2,
  'SELECT' = 2,
  'TOOLTIP' = 2,
  'POPOVER' = 2,
  'ARROW' = 3,
  'OVERLAY' = 2,
}

export const TRIGGER_OVERFLOW = {
  adjustX: 0,
  adjustY: 0,
};

/** Other */

export const NOOP = (): null => null;
